import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  fallbackLng: "en",
  lng: sessionStorage.getItem("appLanguage")
    ? sessionStorage.getItem("appLanguage")
    : "en",
  resources: {
    en: {
      translations: require("./en/translations.json"),
    },
    es: {
      translations: require("./es/translations.json"),
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
  nsSeparator: false
});

i18n.languages = ["en", "es"];

export default i18n;
